import eventBus from "@app2/core/eventBus";
import UpgradeButton from '@app2/core/Components/UpgradeButton.vue';

export default {
  template: `
    <div class="ml-auto">
      <b-btn :id="'card-row-dd-' + index" variant="icon primary ml-auto popover-toggle" @click.stop="">
        <svg viewBox="0 0 24 24" width="24"><use xlink:href="#icon-more"></use></svg>
      </b-btn>
      <b-popover ref="dd" placement="auto" :target="'card-row-dd-' + index" triggers="click blur" >
        <div class="dropdown-cont sm">
          <b-dropdown-item @click.stop="handleSendWelcomeMail">
            <svg class="btn-left icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-send"></use></svg>
            Send Welcome Mail
          </b-dropdown-item>
          <b-dropdown-item @click.stop="handleImpersonate">
            <svg class="btn-left icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-spy"></use></svg>
            Impersonate
            <svg class="icon-sm ml-auto" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-open-external"></use></svg>
          </b-dropdown-item>
          <b-dropdown-item @click.stop="handleEdit">
            <svg class="btn-left icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-pencil"></use></svg>
            Edit
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item variant="warning" @click.stop="handleRemove">
            <svg class="btn-left icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-cross-circle"></use></svg>
            Remove Member
          </b-dropdown-item>
        </div>
      </b-popover>
    </div>
  `,
  data() {
    return {
      index: null,
    }
  },
  components: {
    UpgradeButton,
  },
  methods: {
    handleRemove() {
      this.params.clicked(this.params, 'Remove')
    },
    handleSuspend() {
      this.params.clicked(this.params, 'toSuspend')
    },
    handleEdit() {
      this.params.clicked(this.params, 'Show')
    },
    handleSendWelcomeMail() {
      this.params.clicked(this.params, 'SendWelcomeMail')
    },
    handleImpersonate() {
      this.params.clicked(this.params, 'Impersonate')
    },
  },
  beforeMount() {
    this.index = this.params.data.id
    // TODO: add this when required
    // <b-dropdown-item variant="warning" @click.stop="handleSuspend">
    // <svg class="btn-left icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-suspend"></use></svg>
    // Suspend Access
    // </b-dropdown-item>
  },
};
